import { connect } from 'react-redux';
import {
  mapDispatchToProps,
  mapStateToProps
} from './request-in-progress-utils';
import { RequestInProgress } from './request-in-progress';

export default connect(mapStateToProps, mapDispatchToProps)(RequestInProgress);
